/* TSR MOTION ADDITIONS - August 27, 2026
   Additive only. Reads nothing from and writes nothing to tsr-interactions.js
   or tsr-sparkle-plus.js. Kill switch: window.TSR_FX = { added:false, img:false }
*/
(function () {
  'use strict';

  var CFG = window.TSR_FX || {};
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------------------------------------------------------
     1. Add-to-cart success state
     Dawn already handles press and the loading spinner. This adds the
     missing confirmation on the button itself, held for 1.4s then
     reverted. Interruptible: a second add restarts the timer rather
     than stacking, so rapid adds never leave a stuck label.
     --------------------------------------------------------------- */
  var lastBtn = null;
  var timers = new WeakMap();

  if (CFG.added !== false) {
    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var b = t.closest('.product-form__submit, .quick-add__submit');
        if (b) lastBtn = b;
      },
      true
    );
  }

  function showAdded(btn) {
    if (CFG.added === false) return;
    if (!btn || !btn.isConnected) return;

    var label = btn.querySelector('span');
    if (!label) return;

    if (!btn.dataset.tsrFxLabel) btn.dataset.tsrFxLabel = label.textContent;

    var prev = timers.get(btn);
    if (prev) clearTimeout(prev);

    label.textContent = 'Added ✓';
    btn.classList.add('tsr-fx-added');

    var id = setTimeout(function () {
      btn.classList.remove('tsr-fx-added');
      label.textContent = btn.dataset.tsrFxLabel;
      timers.delete(btn);
    }, 1400);

    timers.set(btn, id);
  }

  function wireCart() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        showAdded(lastBtn);
      });
      return true;
    }
    return false;
  }

  if (!wireCart()) {
    document.addEventListener('DOMContentLoaded', wireCart);
  }

  /* ---------------------------------------------------------------
     2. Card image load-in
     Only the first image in card media - the second is the hover swap
     and is skipped. Images already complete (cached) are skipped
     entirely, so repeat visits never flash. Classes are removed after
     the fade so nothing lingers on the element.
     --------------------------------------------------------------- */
  var IMG_SEL =
    '.card-wrapper .media > img, .featured-products__card .media > img, .card__media .media > img';

  function prepImages(root) {
    if (CFG.img === false) return;
    if (REDUCED.matches) return;

    var imgs = (root || document).querySelectorAll(IMG_SEL);

    Array.prototype.forEach.call(imgs, function (img) {
      var prevEl = img.previousElementSibling;
      if (prevEl && prevEl.tagName === 'IMG') return; /* hover-swap image */
      if (img.dataset.tsrFxImg) return;
      if (img.complete) return; /* cached - leave it alone */

      img.dataset.tsrFxImg = '1';
      img.classList.add('tsr-fx-img');

      var cleared = false;
      var clear = function () {
        if (cleared) return;
        cleared = true;
        img.classList.remove('tsr-fx-img', 'tsr-fx-img-in');
      };

      var done = function () {
        img.classList.add('tsr-fx-img-in');
        setTimeout(clear, 500);
      };

      if (img.complete) {
        clear();
        return;
      }

      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', clear, { once: true });

      /* Safety net: never leave an image invisible if load never fires. */
      setTimeout(function () {
        if (!cleared && !img.classList.contains('tsr-fx-img-in')) clear();
      }, 8000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      prepImages();
    });
  } else {
    prepImages();
  }

  /* ---------------------------------------------------------------
     3. Accordion glide (M4)
     Native <details> content snaps open/closed. This animates the
     content element's height with the Web Animations API so it works
     identically in every browser (the pure-CSS interpolate-size route
     is Chromium-only). Scoped to the FAQ, the salted PDP, and Dawn's
     .accordion details - never the header or menu drawer.
     Reduced motion, or no WAAPI: fall through to the native snap.
     Kill switch: window.TSR_FX = { accordion: false }
     --------------------------------------------------------------- */
  /* body.tsr-fx-ready: added two frames after first paint. CSS uses it to
     keep interaction-entrance animations (tab panel, filtered grid) from
     playing on the initial render, where they read as a load flicker. */
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      document.body.classList.add('tsr-fx-ready');
    });
  });

  var ACC_SEL =
    'details.tsr-faq__item, details.salted-product__accordion, .accordion > details';
  var ACC_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

  document.addEventListener('click', function (e) {
    if (CFG.accordion === false) return;
    if (REDUCED.matches) return;
    if (!e.target || !e.target.closest) return;

    var sum = e.target.closest('summary');
    if (!sum) return;
    var det = sum.parentElement;
    if (!det || det.tagName !== 'DETAILS') return;
    try {
      if (!det.matches(ACC_SEL)) return;
    } catch (err) {
      return;
    }

    var content = sum.nextElementSibling;
    if (!content || typeof content.animate !== 'function') return;

    /* Ignore clicks while a glide is running - 300ms, not worth a reverse. */
    if (det.dataset.tsrAccAnim) {
      e.preventDefault();
      return;
    }

    e.preventDefault();
    det.dataset.tsrAccAnim = '1';
    content.style.overflow = 'hidden';

    var finish = function () {
      content.style.overflow = '';
      delete det.dataset.tsrAccAnim;
    };

    /* The keyframes must animate the content's padding along with its
       height: the FAQ answer carries 22px of its own padding-bottom, and
       height alone leaves that as a visible jump at both ends of the glide
       (box-sizing: border-box cannot shrink below the padding sum). */
    var cs = getComputedStyle(content);
    var full = {
      height: content.getBoundingClientRect().height + 'px',
      paddingTop: cs.paddingTop,
      paddingBottom: cs.paddingBottom,
      opacity: 1
    };
    var zero = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };

    if (det.open) {
      /* fill: forwards holds the collapsed state until [open] is removed -
         without it the content pops back to full height for one frame
         between the animation ending and the close applying. */
      var closeAnim = content.animate([full, zero], {
        duration: 250,
        easing: ACC_EASE,
        fill: 'forwards'
      });
      closeAnim.onfinish = function () {
        det.open = false;
        closeAnim.oncancel = null;
        closeAnim.cancel();
        finish();
      };
      closeAnim.oncancel = function () {
        det.open = false;
        finish();
      };
    } else {
      det.open = true;
      /* Re-measure now that the content is laid out. */
      cs = getComputedStyle(content);
      full = {
        height: content.getBoundingClientRect().height + 'px',
        paddingTop: cs.paddingTop,
        paddingBottom: cs.paddingBottom,
        opacity: 1
      };
      var openAnim = content.animate([zero, full], {
        duration: 300,
        easing: ACC_EASE
      });
      openAnim.onfinish = finish;
      openAnim.oncancel = finish;
    }
  });
})();
